import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeTimeSeconds'
})
export class RemoveTimeSecondsPipe implements PipeTransform {
  transform(date: string): string {
    if (!date) {
      return;
    }

    const splitedDate = date.split(':');

    if (splitedDate.length !== 3) {
      return date;
    }

    return splitedDate.slice(0, splitedDate.length - 1).join(':');
  }
}
